import moment from 'moment';
import ExportJsonExcel from 'js-export-excel';

class GenerateExcelQuerysAndProcedures {
    exportExcel(data, invoice) {
        let option = {};  // La opción representa el archivo de Excel
        let invoiceDetails = this.invoiceDetails(data);
        option.fileName = 'EXC_' + invoice.num_documento.split("-")[0] + invoice.num_documento.split("-")[1];  // Nombre del archivo Excel
        option.datas = [
            {
                sheetData: invoiceDetails.data,  // Fuente de datos en archivo Excel
                sheetName: option.fileName,  // nombre de la página de hoja en el archivo de Excel
            }
        ]
        let toExcel = new ExportJsonExcel(option);  // Generar archivo de Excel
        toExcel.saveExcel();  // Descargar archivo de Excel
    }

    invoiceDetails(details) {
        let dataTable = [];  // Contenido de datos en archivo Excel
        let titlesExcel = this.generateTitlesInvoiceExcel();//Titulos de la Factura
        dataTable.push(titlesExcel);
        
        for (let i = 0; i < details.length; i++) {
            let detailExcel = this.generateInvoiceDetailBoxs(details[i]);//Detalles de la FActura
            dataTable.push(detailExcel);
        }

        let sheet =
        {
            data: dataTable
        }

        return sheet;
    }

    generateTitlesInvoiceExcel() {
        let Titulos = {
            '1': 'Factura',
            '2': 'Fecha',
            '3': 'Autorizacion',
            '4': 'TipoDocumento',
            '5': 'Historia',
            '6': 'Paciente',
            '7': 'Historia_P::Sexo',
            '8': 'L_MD',
            '9': 'Cod_Procedimiento',
            '10': 'L_Procedimiento',
            '11': 'Dx_Previo',
            '12': 'L_DX_Previo',
            '13': 'Entidad_Codigo',
            '14': 'Entidad_Nombre',
            '15': '#_Sesiones',
            '16': 'Valor_Procedimiento x Item',
            '17': 'Valor_Copago x Item',
            '18': 'Valor_Neto x Item',
        }
        return Titulos;
    }

    generateInvoiceDetailBoxs(details) {
        let Casillas = {
            '1':    details.consecutivo != null && details.consecutivo != undefined ? details.consecutivo : "",
            '2':    details.fecha != null && details.fecha != undefined ? details.fecha : "",
            '3':    details.codigo_autorizacion != null && details.codigo_autorizacion != undefined ? details.codigo_autorizacion : "",
            '4':    details.tip_documento_paciente != null && details.tip_documento_paciente != undefined ? details.tip_documento_paciente : "",
            '5':    details.num_documento != null && details.num_documento != undefined ? details.num_documento : "",
            '6':    details.nombre_paciente != null && details.nombre_paciente != undefined ? details.nombre_paciente : "",
            '7':    details.sexo != null && details.sexo != undefined ? details.sexo : "",
            '8':    details.nombre_profesional != null && details.nombre_profesional != undefined ? details.nombre_profesional : "",
            '9':    details.cod_procedimiento != null && details.cod_procedimiento != undefined ? details.cod_procedimiento : "",
            '10':    details.l_procedimiento != null && details.l_procedimiento != undefined ? details.l_procedimiento : "",
            '11':   details.dx_previo != null && details.dx_previo != undefined ? details.dx_previo : "",
            '12':   details.l_dx_previo != null && details.l_dx_previo != undefined ? details.l_dx_previo : "",
            '13':   details.codigosgsss != null && details.codigosgsss != undefined ? details.codigosgsss : "",
            '14':   details.nombre_tercero != null && details.nombre_tercero != undefined ? details.nombre_tercero : "",
            '15':   details.num_sesiones != null && details.num_sesiones != undefined ? details.num_sesiones : "",
            '16':   details.valor_servicio_item != null && details.valor_servicio_item != undefined ? details.valor_servicio_item : "",
            '17':   details.valor_copago_item != null && details.valor_copago_item != undefined ? details.valor_copago_item : "",
            '18':   details.valor_neto_item != null && details.valor_neto_item != undefined ? details.valor_neto_item : ""
        }
        return Casillas;
    }

}
export default new GenerateExcelQuerysAndProcedures();